import { MaskitoOptions, maskitoTransform } from '@maskito/core';
import { Country } from '../../core';

export class PhoneNumberUtils {
  public static formatFullPhoneNumber(
    phoneNumber: string | null | undefined,
    countryCode: string | null | undefined = null,
  ) {
    phoneNumber ??= '';

    phoneNumber = phoneNumber.replace('+', '');
    let formattedPhoneNumber;
    switch (phoneNumber.length) {
      case 11:
        formattedPhoneNumber = maskitoTransform(phoneNumber, this.maskitoOptions11Digit);
        break;
      case 12:
        formattedPhoneNumber = maskitoTransform(phoneNumber, this.maskitoOptions12Digit);
        break;
      case 13:
        formattedPhoneNumber = maskitoTransform(phoneNumber, this.maskitoOptions13Digit);
        break;
      default:
        formattedPhoneNumber = phoneNumber;
        break;
    }
    return countryCode ? `${countryCode} ${formattedPhoneNumber}` : formattedPhoneNumber;
  }

  public static trimCountryCode(
    phoneNumber: string | null | undefined,
    countryCode: string | null | undefined,
    countries: Country[] | null | undefined,
  ) {
    phoneNumber ??= '';
    countryCode ??= '';
    countries ??= [];
    const phoneCode = countries.find(c => c.countryCode === countryCode)?.phoneCode ?? '';
    return phoneNumber.replace(phoneCode, '').trim();
  }

  public static formatShortPhoneNumber(phoneNumber: string) {
    return maskitoTransform(phoneNumber, this.maskitoOptions10Digit);
  }

  public static maskitoOptions10Digit: MaskitoOptions = {
    mask: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  };

  public static maskitoOptions11Digit: MaskitoOptions = {
    mask: ['+', /\d/, ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  };

  public static maskitoOptions12Digit: MaskitoOptions = {
    mask: ['+', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  };

  public static maskitoOptions13Digit: MaskitoOptions = {
    mask: ['+', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  };
}
